import React from 'react';
import GridFilterItem from '../../../Base/Components/GridFilter/GridFilterItem';
import { GridFilterItemType } from '../../../Base/Enums/GridFilterItemType.enum';
import GridFilter from '../../../Base/Components/GridFilter/GridFilter';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import { getMomentDate } from '../../../../Utils/dates.util';
import useFilters from '../../../Base/Hooks/useFilters';
import { GRID_FILTER_KEYS } from '../../../Base/Components/GridFilter/gridFilterKeys';

export interface MonitoringCenterNewRequestsFilterValues {
	caseTypeIds?: string[];
	priorityId?: string;
	patientId?: string;
	date?: string;
	caseStatusValue?: string;
	doctorId?: string;
	attendingDoctorId?: string;
	workplaceId?: string;
	createdAt?: 'BEFORE_1' | 'BEFORE_3' | 'BEFORE_7';
	code?: string;
	caseTypeCode?: string;
	take?: number;
}

interface Props {
	onFilter: (values: MonitoringCenterNewRequestsFilterValues) => void;
}

const MonitoringCenterNewRequestsFilter: React.FC<Props> = ({ onFilter }) => {
	const { handleSelectValue } = useFilters();
	const onFilterData = (values: any) => {
		const filter: MonitoringCenterNewRequestsFilterValues = {
			caseTypeIds: values?.caseTypeIds?.length
				? values.caseTypeIds.map((item: SelectValue) => item.value)
				: undefined,
			priorityId: values?.priorityId?.value || undefined,
			patientId: values?.patient?.value || undefined,
			createdAt: values?.createdAt?.value || undefined,
			caseStatusValue: values?.caseStatus?.value,
			attendingDoctorId: handleSelectValue(values?.attendingDoctor?.value),
			doctorId: handleSelectValue(values?.assignedDoctor?.value),
			workplaceId: handleSelectValue(values?.workplaceId?.value),
			code: values?.code || undefined,
			caseTypeCode: values?.caseTypeCode?.value,
			take: 4,
		};
		onFilter(filter);
	};

	return (
		<GridFilter
			onChange={onFilterData}
			storageKey={
				GRID_FILTER_KEYS.MONITORING_CENTER_NEW_REQUESTS_FILTER
			}>
			<GridFilterItem
				type={GridFilterItemType.CASE_PRIORITY}
				width={280}
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.PATIENT_ID}
				width={330}
				customPlaceholder='base.startTypingSurname'
				enableAutocomplete
			/>
			<GridFilterItem
				customLabel='Stav'
				type={GridFilterItemType.CASE_STATUS}
				width={190}
				enableAutocomplete
				customPlaceholder='base.shared.pick'
			/>
			<GridFilterItem
				type={GridFilterItemType.CASE_CREATE_DAY}
				width={220}
				enableAutocomplete
				customLabel='component.monitoringCenter.filter.created'
				customPlaceholder='base.shared.pick'
			/>
			<GridFilterItem
				type={GridFilterItemType.CASE_CODE}
				width={220}
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.DOCTOR_ID}
				width={330}
				customLabel='base.shared.attendingDoctor'
				customPlaceholder='base.startTypingSurname'
				customKey='attendingDoctor'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.DOCTOR_ID}
				width={330}
				customPlaceholder='base.startTypingSurname'
				customKey='assignedDoctor'
				enableAutocomplete
			/>
			<GridFilterItem
				type={GridFilterItemType.WORKPLACE}
				width={330}
				enableAutocomplete
			/>
		</GridFilter>
	);
};

export default MonitoringCenterNewRequestsFilter;
